module.exports = __webpack_public_path__ + "img/dps.808a3e77.png";